module.exports = __webpack_public_path__ + "img/link.949c9b2c.svg";